import { render, staticRenderFns } from "./CallDirection.vue?vue&type=template&id=0850e501&scoped=true"
import script from "./CallDirection.vue?vue&type=script&lang=js"
export * from "./CallDirection.vue?vue&type=script&lang=js"
import style0 from "./CallDirection.vue?vue&type=style&index=0&id=0850e501&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0850e501",
  null
  
)

export default component.exports